import { Link } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { FileText, Download, ExternalLink, Folder } from "lucide-react";

const DOCS = [
  {
    icon: FileText,
    title: "Statuto Per Asciano",
    desc: "Documento ufficiale dell'associazione (PDF).",
    href: "/documenti/statuto-per-asciano.pdf",
    type: "internal",
    badge: "PDF",
  },
  {
    icon: FileText,
    title: "Report Prima Riunione · 19/06/2026",
    desc: "Sintesi della prima riunione aperta ai cittadini.",
    href: "/documenti/report-riunione-19-giugno-2026.pdf",
    type: "internal",
    badge: "PDF",
  },
  {
    icon: ExternalLink,
    title: "Rischio incendi LAMMA",
    desc: "Monitoraggio ufficiale del rischio incendi della Regione Toscana.",
    href: "https://www.lamma.toscana.it/meteo/rischio-incendi",
    type: "external",
    badge: "Esterno",
  },
  {
    icon: ExternalLink,
    title: "Geoportale Difesa del Suolo",
    desc: "Mappe ufficiali su frane, dissesto, vincoli e territorio.",
    href: "https://geoportale.lamma.rete.toscana.it/difesa_suolo/#/viewer/265",
    type: "external",
    badge: "Esterno",
  },
];

export default function DocumentiPage() {
  return (
    <Layout>
      <section className="bg-[#1f2d22] text-white py-16 sm:py-20" data-testid="documenti-header">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-4 py-1.5 mb-5">
            <Folder className="w-3.5 h-3.5 text-[#E8C9A0]" />
            <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em] text-[#E8C9A0]">
              Documenti utili
            </span>
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.05] tracking-tight">
            Archivio <span className="italic font-light text-[#E8C9A0]">documentale.</span>
          </h1>
          <p className="mt-5 text-base sm:text-lg text-white/75 max-w-2xl leading-relaxed">
            Documenti dell'associazione, report, leggi, regolamenti, ordinanze e
            documentazione tecnica del territorio.
          </p>
        </div>
      </section>

      <section className="py-14 sm:py-20 bg-[#FBF9F6]">
        <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 space-y-4">
          {DOCS.map((d) => {
            const Icon = d.icon;
            const external = d.type === "external";
            return (
              <a
                key={d.title}
                href={d.href}
                target={external ? "_blank" : undefined}
                rel={external ? "noopener noreferrer" : undefined}
                download={!external}
                data-testid={`doc-${d.title.toLowerCase().replace(/\s/g, "-")}`}
                className="group flex items-center gap-4 sm:gap-5 rounded-2xl bg-white border-2 border-[#E5E1D8] hover:border-[#2E4F3B] p-5 sm:p-6 transition-colors"
              >
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-[#1A1A1A] text-white flex items-center justify-center shrink-0">
                  <Icon className="w-6 h-6 sm:w-7 sm:h-7" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#C15C3D]">{d.badge}</span>
                  </div>
                  <div className="font-display font-black text-base sm:text-lg text-[#1A1A1A] leading-tight">
                    {d.title}
                  </div>
                  <div className="text-sm text-[#5C5C5C] mt-1 leading-relaxed">{d.desc}</div>
                </div>
                {external ? (
                  <ExternalLink className="w-5 h-5 text-[#5C5C5C] shrink-0 group-hover:text-[#2E4F3B]" />
                ) : (
                  <Download className="w-5 h-5 text-[#5C5C5C] shrink-0 group-hover:text-[#2E4F3B]" />
                )}
              </a>
            );
          })}

          <p className="pt-6 text-center text-xs text-[#5C5C5C] italic">
            Altri documenti saranno aggiunti progressivamente.
          </p>
          <div className="text-center">
            <Link to="/trasparenza" className="text-sm font-bold text-[#2E4F3B] underline">
              Vai alla pagina Trasparenza
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
